<template>
    <flex-container
        :gap="Size.xs"
        align-items="center"
        inline
        justify-content="flex-start"
    >
        <text-decorator bold>
            <slot />
        </text-decorator>
        <button-default @click="emitNewSorting">
            <svg-icon
                :color="'gray-400'"
                :icon="icon"
                :size="IconSize.xxs"
                is-custom-icon
            />
        </button-default>
    </flex-container>
</template>

<script setup lang="ts">
    import { IconSize, Size } from '@keyvue/one-ui';
    import SortIcon from '@keyvue/one-awesome-icons/icons/solid/sort.svg?component';
    import SortDownIcon from '@keyvue/one-awesome-icons/icons/solid/sort-down.svg?component';
    import SortUpIcon from '@keyvue/one-awesome-icons/icons/solid/sort-up.svg?component';
    import { computed } from 'vue';

    export interface Props {
        selectedSort: { column: string, direction: 'ASC' | 'DESC' } | null
        columnName: string
        defaultDirection?: 'ASC' | 'DESC'
    }

    const props = withDefaults(defineProps<Props>(), {
        defaultDirection: 'ASC',
    });

    const emit = defineEmits<{
        (e: 'sort', value: { column: string, direction: 'ASC' | 'DESC' }): void;
    }>();

    const icon = computed(() => {
        if (!props.selectedSort) {
            return SortIcon;
        }

        if (props.selectedSort.column !== props.columnName) {
            return SortIcon;
        }

        if (props.selectedSort.direction === 'ASC') {
            return SortUpIcon;
        }

        return SortDownIcon;
    });

    function emitNewSorting() {
        if (!props.selectedSort) {
            emit('sort', { column: props.columnName, direction: 'ASC' });
            return;
        }

        if (props.selectedSort.column !== props.columnName) {
            emit('sort', {
                column: props.columnName,
                direction: props.defaultDirection,
            });
        } else {
            emit('sort', {
                column: props.columnName,
                direction: props.selectedSort.direction === 'ASC' ? 'DESC' : 'ASC',
            });
        }
    }
</script>
